<template>
  <div class="container sm">
    <spacer :y="12"/>
    <h2 class="text-center fs-4 fw-bold">パスワード設定</h2>
    <spacer :y="4"/>

    <div v-if="invalid">
      <p class="text-center fs-md">
        アクティベートキーが無効です。<br />
        再度ログインをお試しください。
      </p>
    </div>
    <div v-else-if="!flag.sended">
      <p class="text-center fs-md">
        ログインをするためには、仮パスワードからパスワードを変更する必要があります。
      </p>
      <spacer :y="4"/>
    </div>

    <form
      class="form_login form"
      autocomplete="off"
      v-if="!invalid && !flag.sended">
      <div class="form-signin">
        <div class="form-floating">
          <input
            id="password"
            type="password"
            name="password"
            class="form-control"
            placeholder="パスワード"
            v-model.trim="$v.password.$model"
            v-bind:class="{ input_error: validationFlags.password }"
            v-on:input="invalidsCheck('password', $v.password.$invalid)">
          <label for="password">パスワード</label>
        </div>
      </div>

      <p
        class="fs-xs mt-2 fc-red"
        v-if="$v.password.$dirty && $v.password.required.$invalid">
        パスワードを入力してください</p>
      <p
        class="fs-xs mt-2 fc-red"
        v-if="$v.password.$dirty && $v.password.minLength.$invalid">
        パスワードは8文字以上で設定してください</p>

      <div class="mt-4">
        <basic-btn
          @click="submit"
          :disabled="!submitFlag"
          :width="'full'">
        保存</basic-btn>
      </div>
    </form>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { ref } from 'vue';
import { useVuelidate } from '@vuelidate/core';
import { required, minLength } from '@vuelidate/validators';
import {
  Spacer,
  BasicBtn,
} from '@/components/parts';
import cf from '@/mixins/commonFunctions';


export default {
  name: 'SignupPassword',
  mixins: [cf],
  components: {
    Spacer,
    BasicBtn,
  },
  data() {
    return {
      validationFlags: {
        password: false,
      },
      // 無効フラグ
      invalids: {
        password: true,
        minLength: true,
      },
      // パラメータなし等で無効
      invalid: true,
      activatekey: null,
      flag: {
        sended: false,
      },
    };
  },
  created() {
    // パラメータが含まれているか確認
    const query = this.$route.query;
    if (query.activate) {
      this.invalid = false;
      this.activatekey = query.activate;
    }
  },
  setup() {
    const password = ref('');

    const rules = {
      // パスワードは必須で8文字以上
      password: {
        required,
        minLength: minLength(8),
      },
    };

    const $v = useVuelidate(rules, { password });
    return { password, $v };
  },
  computed: {
    ...mapState(['user', 'page']),
    submitFlag() {
      // 無効フラグが全てfalseならばtrueを返却
      return !this.invalids.password;
    },
  },
  methods: {
    /** 無効フラグの更新 */
    invalidsCheck(name, bool) {
      this.invalids[name] = bool;
    },

    /** サブミット */
    submit(e) {
      e.preventDefault();

      // validateチェックは入力時に行われてる
      const data = {
        flag: 1,
        password: this.password,
        activatekey: this.activatekey,
      };

      this.axios({
        method: 'POST',
        url: '/v1/user/create/password',
        data,
      })
        .then((response) => {
          const resData = response.data;
          if (resData.registed && resData.loginId) {
            alert('パスワードを設定しました。\n登録したパスワードでログインし、トップページに遷移します。');
            this.login(resData.loginId);
          } else if (resData.registed) {
            alert('パスワードを設定しました。\n再度ログインしてください。');
            this.$router.push('/login/');
          } else {
            this.invalid = true;
          }
        })
        .catch((error) => {
          if (error.response) console.log(error.response.data);
          else console.log(error);
          this.invalid = true;
        })
        .finally(() => {
          this.flag.sended = true;
        });
    },

    login(loginId) {
      const data = {
        loginType: 'default',
        password: this.password,
        serialId: loginId,
      };

      this.$store.dispatch('user/login/submit', data);
      this.$store.dispatch('user/update');
    },
  },
};
</script>

<style lang="scss">
</style>
